"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Tracking = _interopRequireWildcard(require("@jobmatchme/tracking/es/provider/Tracking"));

var _reactRouterDom = require("react-router-dom");

var _External = require("@jobmatchme/routing/es/provider/External");

var _ThemeProvider = _interopRequireDefault(require("@jobmatchme/ui/es/provider/ThemeProvider"));

var _Authentication = _interopRequireWildcard(require("../../provider/Authentication"));

var _Profile = _interopRequireWildcard(require("../../provider/Profile"));

var _Matches = _interopRequireWildcard(require("../../provider/Matches"));

var _Vertical = _interopRequireWildcard(require("../../provider/Vertical"));

var _RequireAuthentication = _interopRequireDefault(require("../RequireAuthentication"));

var _getApplicationConfig = _interopRequireDefault(require("../../resources/getApplicationConfig"));

var _VerticalSelection = _interopRequireDefault(require("../VerticalSelection"));

var _Route = _interopRequireWildcard(require("../../provider/Route"));

var _LikeDirect = _interopRequireDefault(require("../LikeDirect"));

var _AppTabs = _interopRequireDefault(require("../AppTabs"));

var _Layout = _interopRequireDefault(require("../Layout"));

var _Onboarding = require("@jobmatchme/ui/es/components/styleguide/Onboarding");

var _Judgements = _interopRequireWildcard(require("../../provider/Judgements"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

//import useLocationTracking from '@jobmatchme/routing/es/utils/useLocationTracking'
var App = function App(_ref) {
  var fixedVertical = _ref.fixedVertical,
      optimisticProfile = _ref.optimisticProfile,
      preventDataFetching = _ref.preventDataFetching;

  var _useSearchParams = (0, _reactRouterDom.useSearchParams)(),
      _useSearchParams2 = (0, _slicedToArray2.default)(_useSearchParams, 1),
      searchParams = _useSearchParams2[0];

  var initialVertical = searchParams.get('initialVertical');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThemeProvider.default, {
    variant: 'jmm',
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tracking.default, {
      app: "pc-matching",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Route.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Authentication.default, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(RoutedApp, {
            optimisticProfile: optimisticProfile,
            preventDataFetching: preventDataFetching,
            fixedVertical: fixedVertical || initialVertical
          })
        })
      })
    })
  });
};

var RoutedApp = function RoutedApp(_ref2) {
  var fixedVertical = _ref2.fixedVertical,
      optimisticProfile = _ref2.optimisticProfile,
      preventDataFetching = _ref2.preventDataFetching;
  var naviagte = (0, _reactRouterDom.useNavigate)();
  var location = (0, _reactRouterDom.useLocation)();

  var _useContext = (0, _react.useContext)(_Route.RouteContext),
      internal = _useContext.internal;

  var _useContext2 = (0, _react.useContext)(_Authentication.AuthenticationContext),
      isAuthenticated = _useContext2.isAuthenticated;

  var _useContext3 = (0, _react.useContext)(_Tracking.TrackingContext),
      track = _useContext3.track;

  (0, _react.useEffect)(function () {
    return track('matchingApp');
  }, [track]); //useLocationTracking()
  // Copy optimistic profile to local state, so that we are independent from the actual location state
  // (Nescessary to be able to reload and edit the profile)

  var locationState;

  if (location.state && (0, _typeof2.default)(location.state) === 'object' && 'optimisticProfile' in location.state) {
    locationState = location.state.optimisticProfile;
  }

  var _useState = (0, _react.useState)(optimisticProfile || locationState),
      _useState2 = (0, _slicedToArray2.default)(_useState, 1),
      maybeOptimisticProfile = _useState2[0]; // Delete optimistic profile after it was first retrieved


  (0, _react.useEffect)(function () {
    if (maybeOptimisticProfile && locationState) {
      naviagte(location.pathname, (0, _extends2.default)({}, location, {
        state: undefined,
        replace: true
      }));
    }
  }, [naviagte, maybeOptimisticProfile, location, locationState]);
  var currentVertical = maybeOptimisticProfile ? maybeOptimisticProfile.discriminator || fixedVertical : fixedVertical;
  return isAuthenticated ? /*#__PURE__*/(0, _jsxRuntime.jsx)(RequireAuthApp, {
    currentVertical: currentVertical,
    maybeOptimisticProfile: maybeOptimisticProfile,
    preventDataFetching: preventDataFetching
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactRouterDom.Routes, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
      path: internal.likesigned,
      element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppTabs.default, {
        activeTab: "likesigned"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
      index: true,
      element: /*#__PURE__*/(0, _jsxRuntime.jsx)(RequireAuthApp, {
        currentVertical: currentVertical,
        maybeOptimisticProfile: maybeOptimisticProfile,
        preventDataFetching: preventDataFetching
      })
    })]
  });
};

var RequireAuthApp = function RequireAuthApp(_ref3) {
  var maybeOptimisticProfile = _ref3.maybeOptimisticProfile,
      preventDataFetching = _ref3.preventDataFetching,
      currentVertical = _ref3.currentVertical;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RequireAuthentication.default, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Vertical.default, {
      fixedVertical: currentVertical,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(AuthApp, {
        maybeOptimisticProfile: maybeOptimisticProfile,
        preventDataFetching: preventDataFetching
      })
    })
  });
};

var AuthApp = function AuthApp(_ref4) {
  var maybeOptimisticProfile = _ref4.maybeOptimisticProfile,
      preventDataFetching = _ref4.preventDataFetching;

  var _useContext4 = (0, _react.useContext)(_Route.RouteContext),
      internal = _useContext4.internal;

  var location = (0, _reactRouterDom.useLocation)();

  var _useContext5 = (0, _react.useContext)(_Vertical.VerticalContext),
      vertical = _useContext5.vertical; // Look for optimistic matches


  var jsonFromSession = sessionStorage.getItem('optimistic-matches-' + vertical);

  var _useState3 = (0, _react.useState)(jsonFromSession ? JSON.parse(jsonFromSession) : undefined),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 1),
      maybeOptimisticMatches = _useState4[0]; // Delete optimistic matches after they was first retrieved


  (0, _react.useEffect)(function () {
    if (maybeOptimisticMatches) sessionStorage.removeItem('optimistic-matches-' + vertical);
  }, [maybeOptimisticMatches, vertical]);

  if (typeof vertical === 'undefined') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  }

  var matchingConfig = (0, _getApplicationConfig.default)(vertical);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Onboarding.OnboardingProvider, {
    showHelpToggle: location.pathname === internal.search,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Profile.default, {
      initialProfile: maybeOptimisticProfile,
      matchingConfig: matchingConfig,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Matches.default, {
        matchingConfig: matchingConfig,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Judgements.default, {
          matchingConfig: matchingConfig,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(InitData, {
            optimisticProfile: maybeOptimisticProfile,
            optimisticMatches: maybeOptimisticMatches,
            preventDataFetching: preventDataFetching,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThemeProvider.default, {
              variant: vertical === 'care' ? 'care' : vertical === 'service-gastro' ? 'jmm' : 'truck',
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Layout.default, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactRouterDom.Routes, {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
                    path: internal.returned,
                    element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppTabs.default, {
                      activeTab: "home"
                    })
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
                    path: internal.likesigned,
                    element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppTabs.default, {
                      activeTab: "likesigned"
                    })
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
                    path: internal.likedirect,
                    element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LikeDirect.default, {})
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
                    path: internal.profile,
                    element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppTabs.default, {
                      activeTab: "profile"
                    })
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
                    path: internal.jobs,
                    element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppTabs.default, {
                      activeTab: "jobs"
                    })
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
                    path: internal.verticalTruck,
                    element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerticalSelection.default, {
                      selection: "truck"
                    })
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
                    path: internal.verticalCare,
                    element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerticalSelection.default, {
                      selection: "care"
                    })
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
                    path: internal.verticalLogisticsScheduler,
                    element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerticalSelection.default, {
                      selection: "logistics-scheduler"
                    })
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
                    path: internal.verticalServiceGastro,
                    element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerticalSelection.default, {
                      selection: "service-gastro"
                    })
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
                    path: internal.vertical,
                    element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerticalSelection.default, {})
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
                    path: internal.appHome,
                    element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppTabs.default, {
                      activeTab: "search"
                    })
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_External.Route, {
                    path: "home/*",
                    element: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppTabs.default, {
                      activeTab: "search"
                    })
                  })]
                })
              })
            })
          })
        })
      })
    })
  });
};

var InitDataComponent = function InitDataComponent(_ref5) {
  var children = _ref5.children,
      optimisticProfile = _ref5.optimisticProfile,
      optimisticMatches = _ref5.optimisticMatches,
      _ref5$preventDataFetc = _ref5.preventDataFetching,
      preventDataFetching = _ref5$preventDataFetc === void 0 ? false : _ref5$preventDataFetc;

  var _useContext6 = (0, _react.useContext)(_Judgements.JudgementsActionsContext),
      fetchJudgements = _useContext6.fetchJudgements;

  var _useContext7 = (0, _react.useContext)(_Matches.MatchesActionsContext),
      fetchMatches = _useContext7.fetchMatches;

  var _useContext8 = (0, _react.useContext)(_Profile.ProfileActionsContext),
      fetchProfile = _useContext8.fetchProfile;

  var _useContext9 = (0, _react.useContext)(_Authentication.AuthenticationContext),
      isAuthenticated = _useContext9.isAuthenticated,
      isLoading = _useContext9.isLoading;

  var storeForGoogleAnalytics = function storeForGoogleAnalytics(profile) {
    try {
      if (localStorage.getItem('profileGA')) {
        localStorage.removeItem('profileGA'); // Remove old values

        localStorage.setItem('profileGA', JSON.stringify(profile));
      } else {
        localStorage.setItem('profileGA', JSON.stringify(profile));
      }
    } catch (error) {
      return console.error('Error: ', error);
    }
  };

  (0, _react.useEffect)(function () {
    var initialize = /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var profile;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!isAuthenticated) {
                  _context.next = 10;
                  break;
                }

                _context.t0 = optimisticProfile;

                if (_context.t0) {
                  _context.next = 6;
                  break;
                }

                _context.next = 5;
                return fetchProfile();

              case 5:
                _context.t0 = _context.sent;

              case 6:
                profile = _context.t0;

                if (profile) {
                  storeForGoogleAnalytics(profile);
                  fetchMatches(profile, optimisticMatches).then(function () {
                    return fetchJudgements().then(function () {
                      return;
                    });
                  });
                }

                _context.next = 11;
                break;

              case 10:
                if (optimisticProfile) {
                  fetchMatches(optimisticProfile);
                }

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function initialize() {
        return _ref6.apply(this, arguments);
      };
    }();

    if (!preventDataFetching && !isLoading) initialize();
  }, [isAuthenticated, isLoading, fetchJudgements, fetchMatches, optimisticProfile, preventDataFetching, fetchProfile, optimisticMatches]);
  return children;
};

var InitData = /*#__PURE__*/(0, _react.memo)(InitDataComponent);

var _default = /*#__PURE__*/(0, _react.memo)(App);

exports.default = _default;